
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.solutions-tabs');

    sections.forEach(section => {
        const navItems = section.querySelectorAll('.solutions-tabs__nav-item');
        const contents = section.querySelectorAll('.solutions-tabs__content');

        // Initialize Swipers
        const swipers = {};
        contents.forEach(content => {
            const swiperContainer = content.querySelector('.swiper');
            if (!swiperContainer) return;

            const blockId = swiperContainer.dataset.blockId;
            const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;


            const swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 16,
                watchOverflow: true,
                scrollbar: {
                    el: swiperContainer.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 1,
                        spaceBetween: 12,
                    },
                    750: {
                        slidesPerView: 3.2,
                        spaceBetween: 12,
                    },
                    1000: {
                        slidesPerView: 3.5,
                        spaceBetween: 24,
                    }
                },
                on: {
                    init: function () {
                        // Adjust visual state if needed
                    }
                }
            });

            swipers[blockId] = swiper;
        });

        // Tab Switching Logic
        navItems.forEach(item => {
            item.addEventListener('click', () => {
                const targetId = item.dataset.tabTarget;

                // Update Nav
                navItems.forEach(nav => {
                    nav.classList.remove('active');
                    nav.setAttribute('aria-selected', 'false');
                });
                item.classList.add('active');
                item.setAttribute('aria-selected', 'true');

                // Update Content
                contents.forEach(content => {
                    content.classList.remove('active');
                    const contentId = content.dataset.tabContent;
                    if (contentId === targetId) {
                        content.classList.add('active');
                        // Update swiper to ensure it recalculates layout after becoming visible
                        if (swipers[contentId]) {
                            swipers[contentId].update();
                        }
                    }
                });
            });
        });
    });
});
